import * as simulatorApi from "./api";
import * as actionTypes from "./actionTypes";
import { sendHttpRequest } from "actions/actionCreators/httpActions";
import { showError, showInfo } from "actions/actionCreators/snackbarActions";
import { sendHttpCommandAndWaitForEvent } from "actions/actionCreators/httpActions";
import * as eventTypes from "./eventTypes";

export function loadSimulatorAssets(filterValues, pager) {
  return async (dispatch, getState) => {
    let simulatorData = getState().simulatorData.assets;
    if (simulatorData.loading) return;

    dispatch({ type: actionTypes.LOAD_SIMULATOR_ASSET_STARTED });
    try {
      await dispatch(sendHttpRequest(simulatorApi.getSimulatorAssets(filterValues, pager)));
      dispatch({ type: actionTypes.LOAD_SIMULATOR_ASSET_SUCCEEDED });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_SIMULATOR_ASSET_FAILED, payload: { error } });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadFinancialProducts(simulationValues, callback = () => {}) {
  return async dispatch => {
    try {
      dispatch({ type: actionTypes.LOAD_SIMULATOR_PRODUCTS_STARTED });
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          simulatorApi.getSimulationsInMemory(simulationValues),
          null,
          [eventTypes.GENERATE_SIMULATIONS_IN_MEMORY_COMPLETED],
          false
        )
      );
      if (event.ok) {
        dispatch({ type: actionTypes.LOAD_SIMULATOR_PRODUCTS_SUCCEEDED });
        callback(event.eventBody);
        return event.eventBody;
      } else {
        dispatch({ type: actionTypes.LOAD_SIMULATOR_PRODUCTS_FAILED, payload: { ...event.eventBody.error } });
        dispatch(showError(event.error.message));
      }
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_SIMULATOR_PRODUCTS_FAILED, payload: { error } });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function createOfferFromSimulator(offer, callback = () => {}) {
  return async dispatch => {
    try {
      dispatch({ type: actionTypes.SAVE_OFFER_FROM_SIMULATOR_STARTED });
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          simulatorApi.saveOfferFromSimulator(offer),
          null,
          [eventTypes.OFFER_CREATED_EMAIL_NOTIFICATION],
          false
        )
      );
      if (event.ok) {
        dispatch(showInfo(event.eventBody.message, false));
        dispatch({ type: actionTypes.SAVE_OFFER_FROM_SIMULATOR_SUCCEEDED });
        callback(event.eventBody);
        return event.eventBody;
      } else {
        dispatch({ type: actionTypes.SAVE_OFFER_FROM_SIMULATOR_FAILED, payload: { ...event.eventBody.error } });
        dispatch(showError(event.error.message));
      }
    } catch (error) {
      dispatch({ type: actionTypes.SAVE_OFFER_FROM_SIMULATOR_FAILED, payload: { error } });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function createKycSession(kycData, callback = () => {}) {
  return async dispatch => {
    try {
      dispatch({ type: actionTypes.SAVE_OFFER_FROM_SIMULATOR_STARTED });
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(simulatorApi.createKycSession(kycData), null, [eventTypes.KYC_SESSION_SCHEDULED])
      );

      if (event.ok) {
        dispatch({ type: actionTypes.SAVE_OFFER_FROM_SIMULATOR_SUCCEEDED });
        callback(event.eventBody);
        return event.eventBody;
      } else {
        dispatch({ type: actionTypes.SAVE_OFFER_FROM_SIMULATOR_FAILED, payload: { ...event.eventBody.error } });
        dispatch(showError(event.error.message));
      }
    } catch (error) {
      dispatch({ type: actionTypes.SAVE_OFFER_FROM_SIMULATOR_FAILED, payload: { error } });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function resetSimulatorAssets() {
  return dispatch => {
    try {
      dispatch({ type: actionTypes.RESET_SIMULATOR_ASSETS });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}
